module.exports = __webpack_public_path__ + "static/media/hu-HU.8fbbea36.md";